import { css } from '@huspy/styled-system/css';

export const proposalsStyles = {
  bankContainer: css({
    minWidth: '137px',
    h: '34px',
  }),
  bankIconPlaceholder: css({ borderRadius: '50%', width: '32px', height: '32px' }),
  noBankContainer: css({
    minWidth: '137px',
    borderRadius: 'radius-3',
    border: '1px dashed',
    borderColor: 'border-secondary',
    padding: 2,
    px: 4,
    h: '34px',
  }),
  noWrapCell: css({ whiteSpace: 'nowrap' }),
  firstHeaderCell: css({ borderTopLeftRadius: 'radius-4' }),
};
